const DEFAULT_OG_IMAGE = "https://dec-energy.ch/og-default.jpg";

type OGMetaTagsProps = {
  description: string;
  image?: string;
  url: string;
  locale: "it" | "en";
};

// `og:title` is intentionally omitted, vike-react derives it from the page
// `title` setting, so emitting it here too produced duplicate og:title tags.
export function OGMetaTags({
  description,
  image,
  url,
  locale,
}: OGMetaTagsProps) {
  const localeName = locale === "it" ? "it_IT" : "en_US";

  return (
    <>
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image ?? DEFAULT_OG_IMAGE} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:url" content={url} />
      <meta property="og:locale" content={localeName} />
      <meta
        property="og:locale:alternate"
        content={locale === "it" ? "en_US" : "it_IT"}
      />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="DEC Energy" />
    </>
  );
}

type TwitterCardProps = {
  title: string;
  description: string;
  image?: string;
};

export function TwitterCard({ title, description, image }: TwitterCardProps) {
  const cardType = "summary_large_image";

  return (
    <>
      <meta name="twitter:card" content={cardType} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image ?? DEFAULT_OG_IMAGE} />
    </>
  );
}

